import { createApp, h } from "vue";
import "vue-toastification/dist/index.css";
import Toast from "vue-toastification";
import { registerAllComponents } from "./register";
import "element-plus/es/components/base/style/css";

const app = createApp(h("div", { id: "vc" }));
registerAllComponents();

app.use(Toast);

app.mount("#vc");
